<template>
  <b-modal
    :visible="value"
    title="Bổ sung thông tin KPI"
    @hide="closeModal"
    size="lg"
    ignore-enforce-focus-selector="input"
  >
    <ValidationObserver ref="formAdd">
      <form @submit.prevent="">
        <div class="row d-flex align-items-center mb-3">
          <label for="" class="col-sm-3 col-form-label">Lý do bổ sung:</label>
          <div class="col-sm-9">
            {{ reasons }}
          </div>
        </div>
        <ValidationProvider rules="required|note_1000" vid="note" name="Nhập thông tin bổ sung">
          <div class="form-group row" slot-scope="{ errors }">
            <label for="" class="col-sm-12 col-form-label"
              >Nhập thông tin bổ sung<span style="color: red"> *</span>:</label
            >
            <div class="col-sm-12">
              <textarea class="form-control" v-model.trim="formData.note" rows="3"></textarea>
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </div>
        </ValidationProvider>
        <p class="text-bold f-14 py-2 mt-4">Sửa thông tin KPI (nếu cần)</p>
        <ValidationProvider rules="required" vid="transactionCode" name="Mã giao dịch">
          <div class="form-group row" slot-scope="{ errors }">
            <label for="" class="col-sm-3 col-form-label"
              >Mã giao dịch<span style="color: red"> *</span>:</label
            >
            <div class="col-sm-9">
              <input class="form-control" v-model="formData.transactionCode" />
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </div>
        </ValidationProvider>
      </form>
    </ValidationObserver>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-end">
        <b-button variant="" @click="closeModal" class="mr-2"> Huỷ bỏ </b-button>
        <b-button variant="primary" @click="submit"> Lưu lại </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  export default {
    props: ['value', 'dataEdit', 'deviceKpiLogs'],
    data() {
      return {
        show: true,
        formData: {},
        reasons: '',
      }
    },
    watch: {
      value() {
        this.reasons = null
        if (this.value) {
          // created
          this.formData = {}
          this.formData.transactionCode = this.dataEdit?.transactionCode ?? null
          this.reasons = this.deviceKpiLogs[0]?.note
        }
      },
    },
    methods: {
      closeModal() {
        this.$emit('input', false)
      },
      async submit() {
        const isSuccess = await this.$refs.formAdd.validate()
        if (!isSuccess) return
        this.$emit('submit', { ...this.formData })
      },
    },
  }
</script>

<style></style>
